import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import SideDrawer from './SideDrawer';
import { SFPalette } from '@/lib/color';

export default function AppHeader({ title }: { title: string }) {
  return (
    <Stack
      component="header"
      height={48}
      justifyContent="space-between"
      alignItems="center"
      direction="row"
      position="sticky"
      bgcolor={SFPalette.shuffleColor}
      top={0}
      zIndex={100}
    >
      <SideDrawer />
      <Typography variant="h5" fontWeight={700} color="white">
        {title}
      </Typography>
      <IconButton
        sx={{
          px: 0,
          width: 24,
        }}
      >
        {/* <SFBellIcon /> */}
      </IconButton>
    </Stack>
  );
}
